import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { signInWithGoogle, useAuth } from '@/lib/firebase';
import { EXTENSION_TAB_MODE_KEY } from '@/lib/auth-extension';
import { PRODUCT_NAME } from '@/lib/brand';

export default function AuthPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading } = useAuth();
  const modeTab = searchParams.get('mode') === 'tab';

  // When not in extension tab mode, redirect to app if already signed in
  useEffect(() => {
    if (loading || modeTab) return;
    if (user) navigate('/', { replace: true });
  }, [user, loading, modeTab, navigate]);

  async function handleSignIn() {
    if (modeTab) {
      // Extension tab: use redirect flow (no popup) to avoid COOP and ensure result reaches extension
      sessionStorage.setItem(EXTENSION_TAB_MODE_KEY, 'tab');
      await signInWithGoogle(false); // redirect
      return;
    }
    try {
      await signInWithGoogle(true); // popup
      navigate('/', { replace: true });
    } catch (err) {
      console.error('Sign-in error:', err);
    }
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-mirror-bg text-mirror-muted text-lg">
        Loading…
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-6 bg-mirror-bg">
      <div className="w-full max-w-[360px] rounded-xl border border-mirror-border bg-mirror-card p-8 text-center">
        <h1 className="font-display mb-2 text-2xl font-semibold tracking-wide text-mirror-gold">{PRODUCT_NAME}</h1>
        <p className="mb-6 text-[0.95rem] text-mirror-muted">Sign in with Google to continue</p>
        <button
          type="button"
          className="inline-block rounded-lg bg-mirror-gold px-6 py-3 text-base font-semibold text-mirror-bg hover:bg-mirror-gold-hover transition-colors disabled:cursor-not-allowed disabled:opacity-60"
          onClick={handleSignIn}
        >
          Sign in with Google
        </button>
        <p className="mt-5 text-xs leading-snug text-mirror-muted">
          Use this in the browser for the full app, or complete sign-in here and return to the
          extension.
        </p>
      </div>
    </div>
  );
}
